import { LessonPlanDocumentType, LessonPlanType } from "../../../types/LessonPlan";
import { put } from "../../../utils/axios-config";
import { LESSON_PLANS, LESSON_PLANS_DOCUMENTS } from "../../../utils/constants";

export const updateLessonPlan = async (data: LessonPlanType) => {
  return await put<LessonPlanType, string>(LESSON_PLANS, data);
};

export const updateLessonPlanDocument = async (data: LessonPlanDocumentType) => {
return await put<LessonPlanDocumentType, string>(LESSON_PLANS_DOCUMENTS, data);
};